export default function getClientAdminURL() {
  return '/insightweb/endUser/changeInternalUserRole?roleType=InternalRole'
}
